import React from 'react';

import { Toaster } from 'react-hot-toast';

import { useAppLocale } from './LocaleProvider';

import config from '../config';



/** Locale-aware toast host — centered like EN; message text follows locale direction. */

export const RtlToaster: React.FC = () => {

  const { direction } = useAppLocale();

  const isRtl = direction === 'rtl';



  return (

    <Toaster

      position="top-center"

      containerClassName="app-hot-toast-host"

      containerStyle={{ direction: 'ltr' }}

      toastOptions={{

        duration: config.ui.toastDuration,

        style: {

          background: '#363636',

          color: '#fff',

          fontFamily: isRtl ? 'var(--font-persian)' : 'var(--font-english)',

          direction,

          textAlign: isRtl ? 'right' : 'left',

        },

        success: { style: { background: '#10b981' } },

        error: { style: { background: '#ef4444' } },

      }}

    />

  );

};


